<template>
<div class="h-full w-full min-h-screen relative" >
<img src="@/assets/images/WEB2.jpg" class="fixed h-screen w-full  "/>
<Loading v-show="loading" :loading="loading"/>
  <Container back_ground_color='md:p-20 sm:p-20 h-full xs:p-0 xs:bg-white '>
     <Modal v-show="show_message_modal"
        v-bind:display="show_message_modal"
        :error="this.error"
        :success="this.success"
        z_value="z-50"
        @positiveClick="closed"
        :positiveButton="'OK'"
        :default_width="'max-w-xl'"
        id='vote_modal'>
       <div class="w-full p-5 flex flex-col text-2xl font-bold text-theme-primary">
            {{ this.modal_message}}
        </div>
    </Modal>
     <Modal v-show="show_selfie_modal"
        v-bind:display="show_selfie_modal"
        z_value="z-50 m-0"
        :default_width="'max-w-xl static_modal'"
        @closed="CloseSelfieModal"
        closable
        :title="'Take a Selfie With your ID'"
        id='vote_modal'>
          <div class="w-full p-2" v-if="show_selfie_modal">
                  <TakeAPhoto id="selfie" ref="selfie" required @changed="saveSelfie" v-if="show_selfie_modal"/>
              </div>
    </Modal>
<!--     
    <div class="w-full h-full card-gradient rounded-r-lg flex flex-col relative xs:hidden" >
                <div class="absolute w-full h-full text-center flex overflow-hidden">
                  <div class="bg-[#016b00] w-[100px] ml-[250px] mt-[250px] rounded-full absolute h-[100px]"></div>
                  <div class="bg-[#016b00] w-[100px] ml-[350px] mt-[-15px] rounded-full absolute h-[100px]"></div>
                  <div class="bg-[#016b00] w-[100px] ml-[10px] mt-[10px] rounded-full absolute h-[100px]"></div>
                  <div class="bg-[#016b00] w-[100px] ml-[390px] mt-[400px] rounded-full absolute h-[100px]"></div>
                  <div class="bg-[#016b00] w-[20px] ml-[10px] mt-[150px] rounded-full absolute h-[20px]"></div>
                  <div class="bg-[#016b00] w-[50px] ml-[50px] mt-[250px] rounded-full absolute h-[50px]"></div>
                  <div class="bg-[#016b00] w-full rounded-full h-[580px] mt-[490px]"></div>
                </div>
                <span v-text="'HI-KAMAY-ARI !'" style="text-shadow: 0.10em 0.05em black" class="text-white font-bold w-full text-center pt-16 absolute text-5xl" />
                <img src="@/assets/icons/hi.png"  class="w-full z-40 h-full self-center ml-[50px]"/>
    </div> -->
    <Card max_width="max-w-5xl p-2 relative self-center" :title="''" >
        <div class="w-full flex flex-col p-4 xs:p-1 space-y-2 ">
           <div class="w-full flex flex-col space-y-2">
          <div class="flex flex-col  text-lg font-bold mb-1  ">
            <span v-text="'NAME : ' + name"/>
             <span v-text="'SERIAL : ' + serial"/>
          </div>
          <div class="border border-gray-300 rounded shadow flex flex-col p-1">
          <div class="flex flex-row w-full">
            <div class=" w-full flex flex-row border">
            <div class="self-center font-bold w-full border-r h-full ml-5 content-center"><span v-text="'* '" class="text-red-500"/>Upload an image of your {{type_of_id}} ID (FRONT) </div>
              <div class="self-center w-full max-w-[40%] justify-items-start m-1">
                <UploadFile id="front_id"   ref="frontImage" accept=".jpeg,.png,.jpg,image/*" text="UPLOAD" :componentId="'front_id'" required @changed="update"/>
              </div>
            </div>
          </div>
          <div class="flex flex-row w-full">
            <div class=" w-full flex flex-row border">
            <div class="self-center font-bold w-full border-r h-full ml-5 content-center"><span v-text="'* '" class="text-red-500"/> Upload an image of your {{type_of_id}} ID (BACK) </div>
              <div class="self-center w-full max-w-[40%] justify-items-start m-1">
                <UploadFile id="back_id" ref="backImage" accept=".jpeg,.png,.jpg,image/*" text="UPLOAD" :componentId="'back_id'" required @changed="update"/>
              </div>
            </div>
          </div>
          <div class="flex flex-row w-full" v-show="false">
            <div class=" w-full flex flex-row border">
            <div class="self-center font-bold w-full border-r h-full ml-5 content-center"><span v-text="'* '" class="text-red-500"/> Upload an image of your sponsor ID </div>
              <div class="self-center w-full max-w-[40%] justify-items-start m-1">
                 <UploadFile id="sponsor_id" ref="sponsor_id" accept=".jpeg,.png,.jpg,image/*" text="UPLOAD" :componentId="'sponsor_id'" required @changed="update" />
              </div>
            </div>
          </div>
          <div class="flex flex-row w-full">
            <div class=" w-full flex flex-row border">
            <div class="font-bold w-full border-r h-full ml-5  content-center flex flex-row mt-3">
              <p v-text="'*'" class="text-red-500 mr-[3px]"/>Take a selfie with your ID & Signature 
              </div>
              <div class=" w-full max-w-[40%] justify-items-start m-1">
                 <!-- <UploadFile id="sponsor_id" ref="sponsor_id" accept="image/png, image/jpeg" text="UPLOAD" :componentId="'sponsor_id'" required @changed="update" /> -->
                   <div class="w-full flex flex-col xs:hidden" @click="this.openCamera">
                      <div class=" flex flex-row w-full">
                        <div v-if="!ios" class="border border-dashed text-center   border-gray-300 space-x-1 p-1 hover:border-blue-400 h-[40px] w-[105px] cursor-pointer bg-gray-50 flex rounded flex-row">
                            <div class="self-center content-center w-full space-x-2" v-if="!selfie">
                              <CameraOutlined :style="{fontSize: '20px'}" />
                            <span v-text="'SELFIE'" class="w-full text-[10px] content-center font-bold text-gray-500" v-if="!selfie"/>
                            </div>
                            <img :src="selfie" v-else class="self-center h-[30px] w-[105px]"/>
                            </div>
                            <!-- <UploadFile v-if="ios" id="selfie" ref="selfie" accept=".jpeg,.jpg,.png,image/*" isCamera text="Selfie" :openDialog="dialog" :componentId="'selfie'" required @changed="update" /> -->
                            <div v-if="this.selfie_empty" class="text-red-500 pt-2 pl-6">
                            Please take a selfie
                          </div>
                        <!-- <UploadFile id="front_id"   ref="frontImage"  :componentId="'front_id'" required @changed="update"/> -->
                      </div>
                    </div>
                      <UploadFile v-if="ios" id="selfie" ref="selfie" accept=".jpeg,.jpg,.png,image/*" isCamera text="Selfie" :openDialog="dialog" :componentId="'selfie'" required @changed="update" />
                      <div v-if="this.selfie_empty && ios" class="text-red-500 pt-2 pl-6">
                      Please take a selfie
                      </div>
              </div>
            </div>
          </div>
           <div class="flex flex-row w-full">
            <div class=" w-full flex flex-row border">
            <div class="self-center font-bold w-full border-r h-full ml-5 content-center"><span v-text="'* '" class="text-red-500"/>Add Signature</div>
              <div class="self-center w-full max-w-[40%] justify-items-start m-1">
               <div class=" w-full flex flex-col" @click="show_signature_pad= true">
                <div class=" font-bold  "></div>
                  <div class=" flex flex-row">
                    <div class="border border-dashed border-gray-300 hover:border-blue-400 h-[40px] w-[105px] cursor-pointer bg-gray-50 flex rounded flex-row ">
                        <div class="m-auto flex flex-row space-x-1" v-if="!signature">
                          <img src="@/assets/images/papsi_signature_icon.svg" :style="{height: '20px',width: '20px'}" class="h-5"/>
                          <span v-text="'SIGNATURE'" class="w-full text-[10px] content-center font-bold text-gray-500" v-if="!signature"/>
                          
                        </div>
                        <img :src="signature" v-else class="self-center h-[30px] w-[105px]"/>
                      </div>
                        <div v-if="this.signature_empty" class="text-red-500 pl-6">
                          Please insert signature here
                        </div>
                    <!-- <UploadFile id="front_id"   ref="frontImage"  :componentId="'front_id'" required @changed="update"/> -->
                  </div>
                </div>
                 <!-- <UploadFile id="sponsor_id" ref="sponsor_id" accept="image/png, image/jpeg" text="UPLOAD" :componentId="'sponsor_id'" required @changed="update" /> -->
              </div>
            </div>
          </div>
         <div class="w-full flex flex-col p-2">
            <SignaturePad id="signature" class="w-full flex" @changed="update" v-if="show_signature_pad"/>
         </div>
          <!-- <div class="flex flex-row md:flex-row sm:flex-col xs:flex-col xs:space-x-0">
            <div class=" p-4 my-2 w-full flex flex-col">
            <div class="mb-2 self-center font-bold  ">Upload an image of your {{type_of_id}} ID (FRONT) </div>
              <div class="self-center">
                <UploadFile id="front_id"   ref="frontImage" accept="image/png, image/jpeg" text="UPLOAD" :componentId="'front_id'" required @changed="update"/>
              </div>
            </div>
            <div class=" p-4 my-2 w-full flex flex-col   ">
              <div class="mb-2 self-center font-bold">Upload an image of your {{type_of_id}} ID (BACK) </div>
                <div class="self-center">
                  <UploadFile id="back_id" ref="backImage" accept="image/png, image/jpeg" text="UPLOAD" :componentId="'back_id'" required @changed="update"/>
                </div>
            </div>
            <div class=" p-4 my-2 w-full flex flex-col" v-show="show_dependent_id">
            <div class="mb-2 self-center font-bold  ">Upload an image of your sponsor ID </div>
              <div class="self-center">
                <UploadFile id="sponsor_id" ref="sponsor_id" accept="image/png, image/jpeg" text="UPLOAD" :componentId="'sponsor_id'" required @changed="update" />
              </div>
            </div>
            </div> -->
            <!-- <div class="flex flex-row md:flex-row sm:flex-col xs:flex-col xs:space-x-0"> -->
            <!-- <div class=" p-4 my-2 w-full flex flex-col xs:hidden" @click="this.openCamera">
            <div class="mb-2 self-center font-bold ">Take a selfie with your ID & Signature</div>
              <div class="self-center flex flex-col items-center pt-5">
                <div class="border border-dashed border-gray-300 hover:border-blue-400 h-32 w-32 cursor-pointer bg-gray-50 flex rounded flex-col place-content-center">
                    <div class="m-auto max-h-1 -mb-1" v-if="!selfie">
                      <CameraOutlined :style="{fontSize: '30px'}" />
                    </div>
                    <span v-text="'Take a Selfie'" class="m-auto font-bold text-gray-500" v-if="!selfie"/>
                    <img :src="selfie" v-else/>
                </div>
                    <div v-if="this.selfie_empty" class="text-red-500 pt-2 ">
                    Please take a selfie
                  </div>
                <UploadFile id="front_id"   ref="frontImage"  :componentId="'front_id'" required @changed="update"/>
              </div>
            </div> -->
            <!-- </div> -->
            
              <!-- <div class="w-full p-5 flex flex-col text-2xl font-bold text-theme-primary max-w-lg self-center" v-if="show_selfie_modal">
                <TakeAPhoto id="selfie" ref="selfie" required @changed="update" v-if="show_selfie_modal"/>
            </div> -->
          </div>

          <div class="w-full">
            <div class="flex  text-lg font-bold mb-1  ">
              OTHER REQUIREMENTS 
            </div>
            <div class="border border-gray-300 p-2 rounded shadow flex flex-col">
              <Dropdown notSorted uppercase nonumbers class="pb-1" :id="'dep_selected'" v-if="this.branch_of_service=='DEP'" :componentId="'dep_selected'"  required type="text" :items="dependent_type" :placeholder="'DEPENDENT TYPE'" @changed="chekDependentType"/>
              <div class="w-full bg-gray-200  p-3" v-show="list_requirements.length>0"> 
                  <span v-text="'* '" class="text-red-500"/><span v-text="'LIST OF OTHER REQUIREMENTS'" class="font-bold text-lg"/>
                  <div class="pl-3 flex flex-col">
                     <span v-for="(items,index) in list_requirements" :key="items" v-text="(index+1)+'. '+items" class="text-lg"/>
                  </div>
              </div>
              <p v-text="message" class="text-red-500 w-full pb-2" v-if="message!=null || message!=''"/>
                <a-upload-dragger
                  v-model:fileList="fileList"
                  list-type="picture"
                  :multiple="true"
                  method=""
                  ref="uploaded_file"
                  :maxCount="5"
                  accept=".jpeg,.png,.jpg,image/*"
                  @change="handleChange"
                  
                >
                  <p class="ant-upload-drag-icon">
                    <InboxOutlined></InboxOutlined>
                  </p>
                  <p class="ant-upload-text">Click to upload</p>
                  <template #itemRender="{file,actions}">
                    <div class="w-full flex border border-gray-300 mt-2 p-2  space-x-1">
                      <div class="border flex justify-center  w-full space-x-2 p-3 items-center">
                          <a-image
                          :width="65"
                          :height="65"
                          :preview="false"
                          :src="file.thumbUrl"
                            class="ant-image"
                        />
                        <p v-text="file.name" class="content-center truncate text-lg font-bold w-1/2"/>
                        
                        <Dropdown notSorted uppercase nonumbers :ref="file.uid" @click="showSelectionList" required :componentId="file.uid"  :id="file.uid" type="text" :items="selection" :placeholder="'Description'" @changed="updateUploadedList(file.uid)"/>
                          <TextField uppercase nonumbers :ref="file.uid+'1'" :id="file.uid" type="text" :placeholder="'Remarks'" @changed="update"/>
                        <div @click="actions.remove" class="cursor-pointer content-center">
                            <DeleteOutlined />
                        </div>
                      </div>
                    </div>
                  </template>
                </a-upload-dragger>
                
            </div>
            <Button class="mt-3" text_size="text-xl" :button_text="'SUBMIT'" @click="submit"></Button>
          </div>
        </div>
        </div>
    </Card>
  </Container>
  </div>
</template>
<script>
import { defineComponent } from 'vue';
import 'ant-design-vue/dist/antd.css';
import Modal from '@/components/controls/ModalControl.vue';
import Loading from '@/components/controls/LoadingControl.vue'
import Container from '@/components/sections/ContainerView.vue'
import mixin from "@/mixin";
import { InboxOutlined,DeleteOutlined,CameraOutlined } from '@ant-design/icons-vue';
import Dropdown from '@/components/controls/DropDownControl.vue';
import TextField from '@/components/controls/TextBoxField.vue';
import Card from '@/components/controls/CardView.vue';
import UploadFile from '@/components/controls/AntUpload.vue';
import Button from '@/components/controls/ButtonControl.vue';
import Member from '@/services/Member';
import moment from 'moment';
import SignaturePad from '@/components/controls/SignaturePad.vue';
import TakeAPhoto from '@/components/controls/TakeAPhoto.vue';
import { isAndroid, isMobile } from 'mobile-device-detect';
import { isIOS } from 'mobile-device-detect';

export default defineComponent({
  components:{
    Container,
    Loading,
    TakeAPhoto,
    Modal,
    Card,
    CameraOutlined,
    SignaturePad,
    InboxOutlined,
    DeleteOutlined,
    TextField,
    UploadFile,
    Dropdown,
    Button
  },
  mounted(){
    let that = this;
    // console.log(true);
    if(isMobile){
      if(isIOS) {
        that.ios = true;
      }
      if(isAndroid){
        that.ios = true;
      }
    }
    that.getData();
    // console.log("TOKEN",process.env.VUE_APP_TOKEN)
  },
  mixins: [
    mixin,
  ],
  data(){
    return{
      token:{
        colorPrimary:"#016b00"
      },
      image:'background-image: url(\'' + require('@/assets/images/WEB2.jpg') + '\'); background-repeat: no-repeat; background-position: center; width:100%; background-size: contain;',
      show_message_modal:false,
      loading:false,
      message:'',
      success:false,
      ios:false,
      error:false,
      modal_message:null,
      selection:[],
      list_requirements:[],
      fileList:[],
      name:"",
      dependent_type:["PARENTS","CHILD","SPOUSE"],
      serial:"",
      selfie_empty:false,
      signature_empty:false,
      show_signature_pad:false,
      branch_of_service :"",
      show_selfie_modal:false,
      employee_status :"",
      selfie:"",
      type_of_id:"",
      signature:"",
      front_id:"",
      back_id:"",
      uploaded_list:[],
      dependent_type_selected:"",
      error_message:"",
      all_files:[],
      other_files_has_error:true,
    }
  },
  methods:{
    saveSelfie(e){
          let that = this;
          that.show_selfie_modal = false;
          that.selfie = e.value;
          // state.membership_details.snap = e.value;
      },
       CloseSelfieModal(){
        let that = this;
        that.show_selfie_modal = false;
        that.$refs.selfie.cameraOff();
      },
       chekDependentType(e){
        let that = this;
        that.dependent_type_selected = e.value;
        that.fileList = [];
        that.showSelectionList();
      },
  getData() {
      let that = this;
      that.loading = true;
       
      Member.getApplication(that.$route.query.reference).then(function(postBack){
        
        that.name = postBack.data.data.ff_name  +" " + postBack.data.data.fl_name;
        that.branch_of_service = postBack.data.data.branch_of_service;
        that.serial = postBack.data.data.serial_no;
        that.employment_status = postBack.data.data.employment_status;
        that.loading = false;
        that.check();
        that.showSelectionList();
       
      }).catch(function() {
        that.loading = false;
        that.$router.push("/Not Found")
      });
      
    // console.log("ID",);
  },
  async submit() {
    let that = this;
     let ref = that.$refs;
    
    that.checkUploadedFiles();
        // console.log(that.front_id!="");
        // console.log(that.back_id!="");
        // console.log(that.selfie!="");
        // console.log(that.signature!="");
        // console.log(that.other_files_has_error);
    if((that.front_id !=null && that.front_id !="") &&
       (that.back_id !=null && that.back_id !="") &&
       (that.selfie !=null && that.selfie !="") &&
       (that.signature !=null && that.signature !="") && that.other_files_has_error==false) {
        that.loading = true;
        that.all_files.push({doc:that.front_id,remarks:"front id"})
        that.all_files.push({doc:that.back_id,remarks:"back id"})
        that.all_files.push({doc:that.selfie,remarks:"photo"})
        that.all_files.push({doc:that.signature,remarks:"signature"})
        
        that.uploaded_list.forEach(element => {
          this.all_files.push({doc:element.data,remarks:element.remarks}) 
        });
        
        await that.postItems();
      
    }else{
      that.checkEmpty();
      ref.frontImage.checkEmpty();
      ref.backImage.checkEmpty();
    }
  },
  expire(){
    let that = this;
      Member.expireLink({reference:that.$route.query.reference}).then(function(){
        that.loading = false;
        that.$router.push("/thankyou")
      })
  },
  async postInfo(payload,index,length){
    let that = this;
    await Member.postRequirements(payload).then(function(){
      // console.log(index,length);
      if(index+1==length){
        that.expire();
      }
      // postBack;
    });
  },
  async postItems(){
    let that = this;  
    for(var i=0;i<that.all_files.length;i++){
      let payload = {
        reference:that.$route.query.reference,
        remarks:that.all_files[i].remarks+" 2",
        doc:that.all_files[i].doc,
      }
      await that.postInfo(payload,i,that.all_files.length);
    }
    // that.all_files.forEach(element => {
      
     
    // } );
  },
  updateUploadedList(uid){
    let that = this;
    let ref = that.$refs

    for(let indicator = 0; indicator<that.uploaded_list.length; indicator++){
      // console.log(uid,that.uploaded_list[indicator].ID);
      if(uid == that.uploaded_list[indicator].ID) {
        that.uploaded_list[indicator].remarks = ref[uid].selected;
        if(ref[uid].selected=="OTHERS"){
          ref[uid+"1"].showField();
        }
      }
    }
    // console.log(that.uploaded_list);
    that.checkUploadedFiles();
  },
  async stopMultipletigger(uuid) {
    let that = this;
    let comp = false;
    let new_id = uuid;
   
   for(let i = 0; i<that.uploaded_list.length; i++) {
      if(new_id == that.uploaded_list[i].ID) {
        comp = true;
        break;
      } else {
        comp = false;
        that.old_id = new_id;
      }
   }
    
    return comp;
  },
  check(){
    let that = this;
    let store = that.$store;
    let state = store.state.membership_details;
    that.membership_type = state.mem_type;
    if(state.mem_type == "ASSOCIATE" || state.mem_type == "DEP"){
      that.disable_sc = true;
      that.disable_sc_check = true;
    }
  // console.log(state.employee_status_text);
    if(state.mem_type == "DEP" || state.employee_status_text == "RETIRED")
    {
      that.type_of_id = "government issued ";
    }
    else
    {
      that.type_of_id = "military ";
    }
    
  },
   update(e) {
        // console.log(e);
        let key = e.key;
        let that = this;
        let ref = that.$refs
        that.error_message = false;
        that[key] = e.value;

        that.show_selfie_modal =  false;
        that.show_signature_pad = false;
        that.checkEmpty();
        ref.frontImage.checkEmpty();
        ref.backImage.checkEmpty();
      },
  closed(){
    this.show_message_modal = false;
  },
  async createImage (file) { // <= this must be asynchronous
            const reader = new FileReader();
            let image="";
            // Wait for the data url to be loaded from the file
            const dataURL =  await new Promise(resolve => {
                reader.onload = (e) => resolve(e.target.result);
                reader.readAsDataURL(file);
            });

            // Wait for the image to be loaded
            const img = new Image();
            await new Promise(resolve => {
                img.onload = resolve;
                img.src = dataURL;
            });

            // Resize the image with a canvas
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            
            // This is an addition to keep the aspect ratio of the image so it won't get distorted
            // See : https://stackoverflow.com/q/3971841/12594730
            const [maxWidth, maxHeight] = [720, 720];
            const [imgWidth, imgHeight] = [
                img.naturalWidth,
                img.naturalHeight
            ];
            const ratio = Math.min(maxWidth / imgWidth, maxHeight / imgHeight);

            canvas.width = imgWidth * ratio;
            canvas.height = imgHeight * ratio;

            ctx.drawImage(img, 0, 0, canvas.width, canvas.height);
            image = canvas.toDataURL('image/jpeg', 0.8);
            return image;

      },
  async beforeUpload(file) {
  let that =this;
  // console.log(file);
  // that.createImage(file);
    const isJpgOrPng = file.type === 'image/jpeg' || file.type === 'image/png';
     const isLt2M = file.size / 1024 / 1024 < 25;
    if (!isJpgOrPng) {
      that.$message.error('You can only upload JPG file!');
      that.fileList=[];
      return false;
    }else if (!isLt2M) {
      that.$message.error('Image must smaller than 25MB!');
      that.fileList=[];
      return false;
    }else {
      return true;
    }
    
  },
  async handleChange(e) {
    let that = this;
    let checker=false;
    that.uploaded_list=[];
    // console.log(e);
     if (e.file.status !== 'uploading') {
      for(let i = 0 ; i < that.fileList.length ; i++) {
        checker = that.beforeUpload(that.fileList[i].originFileObj);
        if(checker) {
              if( (await that.stopMultipletigger(that.fileList[i].uid)== false)) {
                let item = {
                ID:that.fileList[i].uid,
                remarks:"",
                data:that.fileList[i].thumbUrl,
                date:moment(that.fileList[i].lastModified).format("MM/DD/YYYY"),
                time:moment(that.fileList[i].lastModified).format("hh:mm:ss A")
              }
              item.data = await that.createImage(that.fileList[i].originFileObj);
              if(that.uploaded_list.length<that.fileList.length) {
                that.uploaded_list.push(item);
              }
            }
        }
      }
      // console.log(that.uploaded_list);
      that.updateUploadedListAll();
    }
 
  },
    updateUploadedListAll(){
    let that = this;
    let ref = that.$refs

    if(that.uploaded_list.length>0){
      for(let indicator = 0; indicator<that.uploaded_list.length; indicator++){
        try{
            that.uploaded_list[indicator].remarks = ref[that.uploaded_list[indicator].ID].selected;
        }catch(e){
          // console.log(message);
        }
      }
    }
      //  console.log(that.uploaded_list[0]);
    // console.log(that.uploaded_list);
  },
  checkRetired() {
    let that = this;
    let ref = that.$refs;
    let ro_exist = false;
    let hd_exist = false;
    let selection1 = "Retirement Order";
    let selection2 = "Honorably Discharged Order";

    if(that.branch_of_service!="DEP" && that.employment_status=="I") {
        for(let line_checker = 0 ; line_checker < that.uploaded_list.length; line_checker++){
        // console.log(ref[that.uploaded_list[line_checker].ID].selected);
        if(ref[that.uploaded_list[line_checker].ID].selected == selection1.toUpperCase()) {
          ro_exist = true;
        } else if (ref[that.uploaded_list[line_checker].ID].selected == selection2.toUpperCase()) {
          hd_exist = true;
        }
      }
      if(ro_exist && hd_exist) {
        that.message="";
        that.other_files_has_error = false;
      }else{
        that.other_files_has_error = true;
        if(!ro_exist) {
          that.message = "Missing " + selection1;
        }
        if(!hd_exist) {
          that.message = "Missing " + selection2;
        }
      }
    }
  },
  checkDependentsParents() {
    let that = this;
    let ref = that.$refs;

    let parents_bcs_exist = false;
    let parents_mcp_exist = false;
    let parents_ppid_exist = false;

    let selection_parent1 = "Marriage Contract";
    let selection_parent2 = "Sponsor's Birth Certificate";
    let selection_parent3 = "Photocopy of PAFCPIC ID of Sponsor";

    if(that.branch_of_service=="DEP" && that.dependent_type_selected == "PARENTS") {
        for(let line_checker = 0 ; line_checker < that.uploaded_list.length; line_checker++){
        if(ref[that.uploaded_list[line_checker].ID].selected == selection_parent1.toUpperCase()) {
          parents_mcp_exist = true;
        } else if (ref[that.uploaded_list[line_checker].ID].selected == selection_parent2.toUpperCase()) {
          parents_bcs_exist = true;
        } else if (ref[that.uploaded_list[line_checker].ID].selected == selection_parent3.toUpperCase()) {
          parents_ppid_exist = true;
        }
      }
      if(parents_bcs_exist && parents_mcp_exist && parents_ppid_exist) {
        that.message="";
        that.other_files_has_error = false;
      }else{
        that.other_files_has_error = true;
        if(!parents_mcp_exist) {
          that.message = "Missing " + selection_parent1;
        }
          if(!parents_bcs_exist) {
          that.message = "Missing " + selection_parent2;
        }
          if(!parents_ppid_exist) {
          that.message = "Missing " + selection_parent3;
        }
      }
    }

  },
  checkDependentsSpouse() {
    let that = this;
    let ref = that.$refs;

    let spouse_mc = false;
    let spouse_ppid_exist = false;

    let selection_spouse1 = "Marriage Contract";
    let selection_spouse3 = "Photocopy of PAFCPIC ID of Sponsor";
    // console.log(that.dependent_type_selected,);
    if(that.branch_of_service=="DEP" && that.dependent_type_selected == "SPOUSE") {
        for(let line_checker = 0 ; line_checker < that.uploaded_list.length; line_checker++){
        if(ref[that.uploaded_list[line_checker].ID].selected == selection_spouse1.toUpperCase()) {
          spouse_mc = true;
        } else if (ref[that.uploaded_list[line_checker].ID].selected == selection_spouse3.toUpperCase()) {
          spouse_ppid_exist = true;
        } 
      }
      if(spouse_mc && spouse_ppid_exist) {
        that.message="";
        that.other_files_has_error = false;
      }else{
        that.other_files_has_error = true;
        if(!spouse_mc) {
          that.message = "Missing " + selection_spouse1;
        }
          if(!spouse_ppid_exist) {
          that.message = "Missing " + selection_spouse3;
        }
      }
    }

  },
  checkActive() {
      let that = this;
      let ref = that.$refs;
      let enre_exist = false;
      let selection1 = "Appointment/Enlistment/Re-enlistment Order";
      // console.log(that.branch_of_service);
      // employment_status
      if(that.branch_of_service!="DEP" && that.employment_status=="A") {
          for(let line_checker = 0 ; line_checker < that.uploaded_list.length; line_checker++){
          // console.log(ref[that.uploaded_list[line_checker].ID].selected);
          if(ref[that.uploaded_list[line_checker].ID].selected == selection1.toUpperCase()) {
            enre_exist = true;
          }
        }
        if(enre_exist) {
          that.other_files_has_error = false;
          that.message = "";
        }else{
          that.other_files_has_error = true;
          if(!enre_exist) {
            that.message = "Missing " + selection1;
          }
        }
      }
    },
     openCamera(){
      this.show_selfie_modal=true;
    },
    checkEmpty(){
        if(this.selfie == null || this.selfie ==''){
            this.selfie_empty =true;
        }else {
          this.selfie_empty = false;
        }
        if(this.signature == null || this.signature == ''){
          this.signature_empty = true;
        }else{
          this.signature_empty = false;
        }
      },

    checkDependentsChild(){
    let that = this;
    let ref = that.$refs;
    let state = that.$store.state;

    let child_bc_exist = false;
    // let mcps_exist = false;
    let ppidc_exist = false;
    let mc_exist = false;

    let selection_child1 = "Marriage Contract(for married female child)";
    let selection_child2 = "Birth Certificate";
    let selection_child3 = "Photocopy of PAFCPIC ID of Sponsor";
    // let selection_child5 = "Marriage Contract(for married female child)";


// that.selection = ["Marriage Contract","Birth Certificate","Photocopy of PAFCPIC ID of Sponsor","Marriage Contract(for married female child)","Others"]
  that.selection = ["Marriage Contract(for married female child)","Birth Certificate","Photocopy of PAFCPIC ID of Sponsor","Others"]
    if(that.branch_of_service=="DEP" && that.dependent_type_selected == "CHILD") {
        for(let line_checker = 0 ; line_checker < that.uploaded_list.length; line_checker++){
          // console.log(state.membership_details.gender)
        if(state.membership_details.civil_status == "mr" && state.membership_details.gender == "F"){
          if(ref[that.uploaded_list[line_checker].ID].selected == selection_child2.toUpperCase()) {
          child_bc_exist = true;
          } else if (ref[that.uploaded_list[line_checker].ID].selected == selection_child3.toUpperCase()) {
            ppidc_exist = true;
          } else if (ref[that.uploaded_list[line_checker].ID].selected == selection_child1.toUpperCase()) {
            mc_exist = true;
          } 
        }else{
          if(ref[that.uploaded_list[line_checker].ID].selected == selection_child2.toUpperCase()) {
            child_bc_exist = true;
          } else if (ref[that.uploaded_list[line_checker].ID].selected == selection_child3.toUpperCase()) {
            ppidc_exist = true;
          }
        }
        
      }
      if(state.membership_details.civil_status == "mr" && state.membership_details.gender == "F"){
        if(child_bc_exist && ppidc_exist && mc_exist) {
        that.other_files_has_error = false;
        that.message = "";
        }else{
          that.other_files_has_error = true;
          if(!child_bc_exist) {
            that.message = "Missing " + selection_child2;
          }
          if(!mc_exist) {
            that.message = "Missing " + selection_child1;
          }
          if(!ppidc_exist) {
            that.message = "Missing " + selection_child3;
          }
        }
      }else{
          if(child_bc_exist && ppidc_exist) {
            that.other_files_has_error = false;
            that.message = "";
        } else { 
          that.other_files_has_error = true;
            if(!child_bc_exist) {
            that.message = "Missing " + selection_child2;
          }
          if(!ppidc_exist) {
            that.message = "Missing " + selection_child3;
          }
        } 
      }
      
    }
  },
  checkUploadedFiles() {
    let that = this;
    let ref = that.$refs;
    // console.log(true);
    if(that.uploaded_list.length>0) {
      for(let line_checker = 0 ; line_checker < that.uploaded_list.length; line_checker++){
            if(ref[that.uploaded_list[line_checker].ID] != null){
              if(ref[that.uploaded_list[line_checker].ID].selected == "") {
                that.other_files_has_error = true;
                break;
              } else {
                ref[that.uploaded_list[line_checker].ID].checkEmpty();
                that.other_files_has_error = false;
              }
            }
      }

      that.checkActive();
      that.checkRetired();

      if(that.dependent_type_selected == "PARENTS"){
          that.checkDependentsParents();
      } else if(that.dependent_type_selected == "SPOUSE"){
          that.checkDependentsSpouse();
      } else if(that.dependent_type_selected == "CHILD"){
          that.checkDependentsChild();
      }

    } else {
      that.other_files_has_error = true;
      
      if(that.dependent_type_selected == "PARENTS"){
        that.message = "Upload the Following Requirements: (Marriage Contract, Sponsor's Birth Certificate, Photocopy of PAFCPIC ID of Sponsor)";
      } else if(that.dependent_type_selected == "SPOUSE"){
        that.message = "Upload the Following Requirements: ( Marriage Contract, Photocopy of PAFCPIC ID of Sponsor )";
      } else if(that.dependent_type_selected == "CHILD"){
        that.message = "Upload the Following Requirements: ( Marriage Contract (for married female child), Birth Certificate,Photocopy of PAFCPIC ID of Sponsor )";
      } else if(that.branch_of_service!="DEP" && that.employment_status=="A"){
        that.message = "Upload the Following Requirements: ( Appointment/Enlistment/Re-enlistment Order )";
      } else if(that.branch_of_service!="DEP" && that.employment_status=="I"){
        that.message = "Upload the Following Requirements: ( Retirement Order, Honorably Discharged Order )";
      }else if(that.branch_of_service=="DEP"){
        that.message = "Select a Dependent Type";
      }
    }
  },
  showSelectionList() {
  
    let that = this;
    //  console.log(that.branch_of_service);

    if(that.branch_of_service == "PAF" || that.branch_of_service == "PA" || that.branch_of_service == "PN"){
      // console.log(state.employee_status);
      if(that.employment_status == "A"){
        that.selection = ["Appointment/Enlistment/Re-enlistment Order","Others"];
        that.list_requirements = ["Appointment/Enlistment/Re-enlistment Order"];
      } else if(that.employment_status == "I") {
        that.selection = ["Retirement Order","Honorably Discharged Order","Others"];
        that.list_requirements  = ["Retirement Order","Honorably Discharged Order"];
      }
    }
    else
    {
      if(that.dependent_type_selected == "PARENTS") {
        that.selection = ["Marriage Contract","Sponsor's Birth Certificate","Photocopy of PAFCPIC ID of Sponsor","Others"];
        that.list_requirements  = ["Marriage Contract","Sponsor's Birth Certificate","Photocopy of PAFCPIC ID of Sponsor"];
      } else if(that.dependent_type_selected == "SPOUSE") {
        that.selection = ["Marriage Contract","Photocopy of PAFCPIC ID of Sponsor","Others"];
        that.list_requirements  =["Marriage Contract","Photocopy of PAFCPIC ID of Sponsor"];
      } else if(that.dependent_type_selected == "CHILD") {
        that.selection = ["Marriage Contract(for married female child)","Birth Certificate","Photocopy of PAFCPIC ID of Sponsor","Others"];
        that.list_requirements  =["Marriage Contract(for married female child)","Birth Certificate","Photocopy of PAFCPIC ID of Sponsor"];
      }
    }
  },
  hideFields(id){
    let that = this;
    let ref = that.$refs;
    ref[id].hideField();
  },
  },
  
  watch:{
    fileList(n){
    setTimeout(() => {
        for(let index = 0 ; index<n.length; index++){
        // console.log(n[index]);
        this.hideFields(n[index].uid+"1");
      }
    }, 100);
      
  },
    basic_info(n){
            setTimeout(() => {
                this.show_step_one = n;
        }, 10);
    },
    address(n){
            setTimeout(() => {
                this.show_step_two = n;
        }, 10);
    },
    famInfo(n){
          setTimeout(() => {
                this.show_step_three = n;
        }, 10);
    },
    otherInfo(n){
          setTimeout(() => {
                this.show_step_four = n;
        }, 10);
    },
    summary(n){
          setTimeout(() => {
                this.show_summary = n;
        }, 10);
    },
  }

})
</script>

<style>
.max-height-container {
  max-height: 80% !important;
}
.ant-steps-item-title{
  font-size: 20px !important;
}
.bg-translucent {
    background-color: rgba(0 ,0 ,0 ,0.75);
}
</style>
